var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},_vm._l((_vm.collection),function(sample,index){return _c('soil-sample-form-group',{key:index,attrs:{"sample":sample,"index":index,"allTestPackages":_vm.allTestPackages},on:{"onSampleChange":_vm.onSampleChange}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }